
class   WindowBCChannel  {

    constructor(nameC,funR) {
        this.nameChannel=nameC;
        this.funRecive = funR;
        this.bc = new BroadcastChannel(this.nameChannel);
        this.Hsend = this.sending.bind(this);
        this.Hreceive = this.receiving.bind(this);
        this.Hleave = this.leave.bind(this);
        this.bc.onmessage = this.Hreceive;
    }

    sending(obj){
        let str=JSON.stringify(obj);
        this.bc.postMessage(str);
    }

    leave(){
        this.bc.close();
    }

    receiving(ev){
        let obj=JSON.parse(ev.data);
        this.funRecive(obj);
    }

}

export default WindowBCChannel;

